import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Pagination } from '@mui/material';
const SmePaginate = ({ onPageChange, page, totalPages }) => {
    return _jsx(_Fragment, { children: _jsx(Pagination, { defaultValue: page, count: totalPages, page: page, color: "primary", onChange: (e, n) => { onPageChange(n); } }) });
};
export default SmePaginate;
